import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaEditorComponent } from 'src/app/shared/ui-kit/pa-editor/pa-editor.component';

@Component({
  selector: 'app-editor-view',
  standalone: true,
  imports: [PaEditorComponent, FormsModule, ReactiveFormsModule],
  templateUrl: './editor-view.component.html',
  styleUrls: ['./editor-view.component.scss'],
})
export class EditorViewComponent {
  private readonly fb = inject(FormBuilder);

  readonly form = this.fb.group({
    text: [
      '<p><b>Заголовок</b>, который можно форматировать.</p><p>Можно форматировать текст и добавлять списки.</p>',
    ],
  });
}
